import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';
import { Tag } from '../core/Tag';

export interface FiltroAplicado {
    id: string;
    label: ReactNode;
}

export interface FilterBarProps {
    /** Normalmente um `<SearchField>`. */
    search?: ReactNode;
    filters?: FiltroAplicado[];
    onAddFilter?: () => void;
    onRemoveFilter?: (id: string) => void;
    actions?: ReactNode;
    /** Ex.: "48 resultados". */
    resultLabel?: ReactNode;
    style?: CSSProperties;
}

export function FilterBar({ search, filters = [], onAddFilter, onRemoveFilter, actions, resultLabel, style }: FilterBarProps) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', ...style }}>
            {search}
            {filters.map((f) => (
                <Tag key={f.id} onRemove={() => onRemoveFilter?.(f.id)}>{f.label}</Tag>
            ))}
            <button
                type="button" onClick={onAddFilter}
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6, height: 30, padding: '0 10px',
                    border: '1px dashed var(--border-strong)', background: 'transparent', borderRadius: 'var(--radius-xs)',
                    cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 12.5, fontWeight: 500, color: 'var(--text-secondary)',
                }}
            >
                <Icon name="plus" size={13} />
                Adicionar filtro
            </button>
            {resultLabel && <span style={{ fontSize: 12.5, color: 'var(--text-tertiary)' }}>{resultLabel}</span>}
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>{actions}</div>
        </div>
    );
}
